export default {
  namespaced: true,
  state: {
    inlineModeSMV: false,
  },
  mutations: {
    setInlineModeSMV(state, payload) {
      state.inlineModeSMV = payload;
    },
  },
  actions: {
    setInlineModeSMV({ commit }, value) {
      commit("setInlineModeSMV", value);
    },
  },
  getters: {
    inlineModeSMV: (state) => state.inlineModeSMV,
  },
};
